class CustomDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const closeButtons = this.querySelectorAll('.drawer__close');
    closeButtons.forEach((button) => {
      button.addEventListener('click', () => this.close());
    });
    this.setDrawerInnerTopSpace();
    this.querySelector('.drawer__overlay').addEventListener('click', this.close.bind(this));
    window.addEventListener(
      'resize',
      debounce(() => {
        this.setDrawerInnerTopSpace();
      }),
    );
  }

  open(callback) {
    this.setDrawerInnerTopSpace();
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');
    if (callback) {
      callback();
    }
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  getSectionsToRender() {
    return [
      {
        selector: '.drawer',
      },
    ];
  }

  setDrawerInnerTopSpace() {
    if (!isDesktop() && this.querySelector('.drawer__inner--fit-height')) {
      this.querySelector('.drawer__inner').style.paddingTop = 0;
    } else {
      const height = getHeaderHeight();
      this.querySelector('.drawer__inner').style.paddingTop = `${height}px`;
    }
  }
}

customElements.define('custom-drawer', CustomDrawer);
